<template>
  <form-shell
    :title="$t('title')"
    :formsOnShell="formsOnShell"
    :successTexts="successTexts"
    :callbackRequest="createPhysicalWorldOrder"
    :makeBodyToRequest="makeBodyToRequest"
    @cancel="handleCancel"
  >
  </form-shell>
</template>
<script>
import { mapActions } from 'vuex'

import FormShell from '@/views/PhysicalWorld/components/FormShell.vue'
import { TERMINAL_ROUTES_ENUM } from '@/enums/physical-world.enum'

import PhysicalWorldManager from '../physical-world.manager'

import {
  FORM_ADDRESS,
  FORM_RECEIVERS,
  FORM_OPEN_HOURS,
  FORM_OBSERVATION
} from './forms-context-terminals.enum'

export default {
  name: 'TerminalRequest',
  components: {
    FormShell
  },
  data () {
    return {
      formsOnShell: [
        FORM_ADDRESS,
        FORM_RECEIVERS,
        FORM_OBSERVATION,
        FORM_OPEN_HOURS
      ],
      successTexts: {
        title: this.$t('success.title'),
        info: this.$t('success.info'),
        content: this.$t('success.content')
      }
    }
  },
  methods: {
    ...mapActions({
      createPhysicalWorldOrder: 'CREATE_PHYSICAL_WORLD_ORDER'
    }),
    makeBodyToRequest () {
      return new PhysicalWorldManager().makeBodyToRequestTerminal()
    },
    handleCancel () {
      this.$router.push({ name: TERMINAL_ROUTES_ENUM.TERMINALS })
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Solicitar Maquininha",
      "button": {
        "submit": "Solicitar"
      },
      "success": {
        "title": "Solicitação de maquininha",
        "info": "Maquininha solicitada com sucesso",
        "content": "Ao clicar no botão abaixo, você será encaminhado para listagem de ordens de serviço para acompanhar sua solicitação."
      }
    },
    "en-US": {
      "title": "Request Terminal",
      "button": {
        "submit": "Request"
      },
      "success": {
        "title": "Request for Terminal",
        "info": "Terminal requested successfully",
        "content": "By clicking the button below, you will be redirected to the service order list to track your request."
      }
    }
  }
</i18n>
